export const businessImageStyles = {
  width: 53,
  height: 53,
  borderRadius: "5px"
}

export const iconStyles = {
  width: "40px",
  height: "40px"
}